export { default, getServerSideProps } from '@/views/Register';
